/**
 * Signing status types for type-safe status updates
 * Using const pattern instead of enum for better bundling compatibility
 */
const SigningStatus = {
    INITIALIZING: 'initializing',
    AUTHENTICATING: 'authenticating',
    PREPARING: 'preparing',
    SIGNING: 'signing',
    SUBMITTING: 'submitting',
    COMPLETED: 'completed',
    ERROR: 'error',
    EXPIRED: 'expired'
};

/**
 * Error codes for transaction signing operations
 */
var TransactionSigningErrorCode;
(function (TransactionSigningErrorCode) {
    TransactionSigningErrorCode["INVALID_TOKENS"] = "INVALID_TOKENS";
    TransactionSigningErrorCode["TRANSACTION_NOT_FOUND"] = "TRANSACTION_NOT_FOUND";
    TransactionSigningErrorCode["TRANSACTION_NOT_PENDING"] = "TRANSACTION_NOT_PENDING";
    TransactionSigningErrorCode["WALLET_NOT_AVAILABLE"] = "WALLET_NOT_AVAILABLE";
    TransactionSigningErrorCode["WEBAUTHN_OPERATION_IN_PROGRESS"] = "WEBAUTHN_OPERATION_IN_PROGRESS";
    TransactionSigningErrorCode["SIGNING_CANCELLED"] = "SIGNING_CANCELLED";
    TransactionSigningErrorCode["PERS_AUTH_FAILED"] = "PERS_AUTH_FAILED";
    TransactionSigningErrorCode["AUTH_FAILED"] = "AUTH_FAILED";
    TransactionSigningErrorCode["TRANSACTION_NOT_READY"] = "TRANSACTION_NOT_READY";
    TransactionSigningErrorCode["SUBMISSION_FAILED"] = "SUBMISSION_FAILED";
    TransactionSigningErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    TransactionSigningErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(TransactionSigningErrorCode || (TransactionSigningErrorCode = {}));

export { SigningStatus, TransactionSigningErrorCode };
//# sourceMappingURL=types.esm.js.map
